<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form v-if="show_form" class="t-trial-application-invite-user-form__form" @submit.prevent="handleSubmitForm">
      <div class="t-trial-application-invite-user-form__fields">
        <label class="m-form-input__label t-trial-application-invite-user-form__pc"
          >氏名<span class="m-form-input__type2">必須</span></label
        >
        <label class="m-form-input__label m-form-input__label2 t-trial-application-invite-user-form__sp"
          >氏名（姓）<span class="m-form-input__type2">必須</span></label
        >
        <m-form-input>
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              id="lastname"
              v-model="formData.lastname"
              type="text"
              placeholder="山田"
              maxlength="20"
              required
              :error="getFieldError('lastname')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.lastname.isError"
              v-html="backendErrorDict.lastname.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <label class="m-form-input__label m-form-input__label2 t-trial-application-invite-user-form__sp"
            >氏名（名）<span class="m-form-input__type2">必須</span></label
          >
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              id="name"
              v-model="formData.name"
              type="text"
              placeholder="太郎"
              maxlength="20"
              required
              :error="getFieldError('name')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.name.isError"
              v-html="backendErrorDict.name.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>

        <label class="m-form-input__label t-trial-application-invite-user-form__pc"
          >氏名カナ<span class="m-form-input__type2">必須</span></label
        >
        <label class="m-form-input__label m-form-input__label2 t-trial-application-invite-user-form__sp"
          >氏名カナ（姓）<span class="m-form-input__type2">必須</span></label
        >
        <m-form-input>
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              id="lastname_kana"
              v-model="formData.lastname_kana"
              type="text"
              placeholder="ヤマダ"
              maxlength="20"
              required
              :error="getFieldError('lastname_kana')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.lastname_kana.isError"
              v-html="backendErrorDict.lastname_kana.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <label class="m-form-input__label m-form-input__label2 t-trial-application-invite-user-form__sp"
            >氏名カナ（名）<span class="m-form-input__type2">必須</span></label
          >
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              id="name_kana"
              v-model="formData.name_kana"
              type="text"
              placeholder="タロウ"
              maxlength="20"
              required
              :error="getFieldError('name_kana')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.name_kana.isError"
              v-html="backendErrorDict.name_kana.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="会社名" type="任意">
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              v-model="formData.company_name"
              type="text"
              placeholder="入力してください"
              :error="getFieldError('company_name')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyName.isError"
              v-html="backendErrorDict.companyName.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="メールアドレス" type2="必須">
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              id="email"
              v-model="formData.email"
              type="text"
              placeholder="xxxx@kaisha.co.jp"
              maxlength="50"
              required
              :error="getFieldError('email')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.adminEmail.isError"
              v-html="backendErrorDict.adminEmail.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>キャリアメールは使えません</li>
          </template>
        </m-form-input>
        <m-form-input label="電話番号" type2="必須">
          <div class="t-trial-application-invite-user-form__includeerror">
            <a-text-field
              id="phone_number"
              v-model="formData.phone_number"
              type="tel"
              placeholder="09012345678"
              maxlength="11"
              required
              :error="getFieldError('phone_number')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.adminPhoneNumber.isError"
              v-html="backendErrorDict.adminPhoneNumber.msg"
              class="t-trial-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>ハイフンは入れずにご入力ください。</li>
          </template>
        </m-form-input>
      </div>
      <div class="t-trial-application-invite-user-form__buttons">
        <m-button-container>
          <a-button id="next" variant="block" submit="submit" color="primary" :disabled="hasErrorflg">次へ</a-button>
          <a-button id="back" color="primary" @click="handleCancelClick">戻る</a-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-modal
        id="trialApplicationInviteUserForm_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import { cloneDeep } from 'lodash';
import OModal from '@/components/organisms/modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { PREFECTURES, TRIAL_SIGNUP_RELIEF_MEASURES_PATH } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

import { utils } from '@/common/utils.js';

export default {
  name: 't-trial-application-invite-user-form',
  components: {
    TDefaultEntrySidebar,
    MFormInput,
    ATextField,
    AButton,
    MButtonContainer,
    OModal,
  },
  mixins: [messageContent, customRequest, customValidate], // #2456
  props: {
    class: {
      type: String,
      default: '',
    },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      hasErrorflg: true,
      formData: {
        lastname: this.$route.params.lastname,
        name: this.$route.params.name,
        lastname_kana: this.$route.params.lastname_kana,
        name_kana: this.$route.params.name_kana,
        adminBirthDate: this.$route.params.adminBirthDate,
        company_name: this.$route.params.company_name,
        phone_number: this.$route.params.phone_number,
        postal_code: this.$route.params.postal_code,
        street_address: this.$route.params.street_address,
        email: this.$route.params.email,
        purpose: this.$route.params.purpose,
      },
      sidebarInfo: {
        sidebarList: [{ label: 'トライアル情報の入力' }, { label: 'トライアル内容確認' }],
        sidebarCurrent: 1,
        heading: 'トライアル情報の入力',
        subHeading: 'Step 1',
        sidebarSubHeading: 'Trial',
        sidebarHeading: 'トライアルお申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      prefectures: [],
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      // #2456
      spCharCheckList: [
        {
          name: '氏名',
          fieldName: 'lastname',
        },
        {
          name: '氏名',
          fieldName: 'name',
        },
        {
          name: '氏名カナ',
          fieldName: 'lastname_kana',
        },
        {
          name: '氏名カナ',
          fieldName: 'name_kana',
        },
        {
          name: '会社名',
          fieldName: 'company_name',
        },
        {
          name: 'メールアドレス',
          fieldName: 'email',
        },
        {
          name: '電話番号',
          fieldName: 'phone_number',
        },
      ],
      backendErrorDict: {
        lastname: {
          isError: false,
          msg: '',
        },
        name: {
          isError: false,
          msg: '',
        },
        lastname_kana: {
          isError: false,
          msg: '',
        },
        name_kana: {
          isError: false,
          msg: '',
        },
        companyName: {
          isError: false,
          msg: '',
        },
        adminEmail: {
          isError: false,
          msg: '',
        },
        adminPhoneNumber: {
          isError: false,
          msg: '',
        },
      },
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-trial-application-invite-user-form');
      return `${baseClassName} ${this.class}`.trim();
    },
    hasError() {
      let isValid = true;
      if (this.errorList) {
        isValid = !Object.keys(this.errorList).length > 0;
      }
      return isValid;
    },
  },
  async created() {
    document.title = 'トライアル情報の入力 | COTOHA Call Center';

    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: TRIAL_SIGNUP_RELIEF_MEASURES_PATH });
      return; // #2314
    }

    this.fetchTmpDataHandler();
  },
  mounted() {
    this.prefectures = PREFECTURES;
    this.show_form = true;
    utils.setMetaDescription(this.$route);
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSubmitForm(e) {
      e.preventDefault();

      // #2456
      for (const item of this.spCharCheckList) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.formData[item.fieldName].replace(/\r?\n/g, '') })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return;
        }
      }

      const data = {
        lastname: this.formData.lastname,
        name: this.formData.name,
        lastname_kana: this.formData.lastname_kana,
        name_kana: this.formData.name_kana,
        adminEmail: this.formData.email,
        companyName: this.formData.company_name,
        adminPhoneNumber: this.formData.phone_number,
      };

      const formDataTmp = {
        tmpCompanyID: this.tmpUUID,
        tmpYMD: this.tmpYMD,
        validate: true,
        data: data,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      fetch('/signup/updateHistoryCollectionTrial', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = TRIAL_SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              if (Array.isArray(e.errors)) {
                this.setBackendErrorMsg(e.errors);
                const errMsg = e.errors.map(e => e.msg).join('<br />');
                this.showErrorModal(errMsg);
              } else if (e.msg) {
                this.showErrorModal(e.msg);
              } else {
                this.showErrorModal(messageContent.requireTry('トライアル情報の入力'));
              }
              return {};
            }

            this.$router.push({ path: '/trial-signup/confirm' });
            return {};
          } else {
            window.location.href = TRIAL_SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('トライアル情報の入力'));
        });
    },
    // エラーリストを更新（引数無しで呼び出すとエラーを全て空にする）
    setBackendErrorMsg(errors) {
      Object.keys(this.backendErrorDict).forEach(fieldName => {
        this.backendErrorDict[fieldName].isError = false;
        this.backendErrorDict[fieldName].msg = '';
      });
      if (!Array.isArray(errors)) return;
      for (const error of errors) {
        if (typeof error.param !== 'string') continue;
        const fieldName = error.param.split('.').slice(-1)[0];
        const target = this.backendErrorDict[fieldName];
        target.isError = true;
        target.msg += target.msg === '' ? error.msg : `<br />${error.msg}`;
      }
    },
    getFieldError(key) {
      this.hasErrorflg = false;

      const arrInput = ['lastname', 'name', 'lastname_kana', 'name_kana', 'email', 'phone_number'];

      for (let i = 0; i < arrInput.length; i++) {
        if (this.formData[arrInput[i]] === '') {
          this.hasErrorflg = true;
          return;
        }
      }
    },
    handleCancelClick() {
      this.$router.push(TRIAL_SIGNUP_RELIEF_MEASURES_PATH);
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
          this.csrfToken = e.csrfToken;
          document.querySelector('meta[name="csrf-token"]').setAttribute('content', e.csrfToken);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('トライアル情報取得'));
        });
    },
    fetchTmpDataHandler: async function () {
      const formDataTmp = {
        tmpCompanyID: this.tmpUUID,
        tmpYMD: this.tmpYMD,
        collectionType: 'historyCollection',
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return await fetch('/signup/getCollection', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = TRIAL_SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/getCollection response was not ok.');
            }
            this.setCurrentValue(e.data);
            return {};
          } else {
            window.location.href = TRIAL_SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('トライアル情報の入力'));
        });
    },
    setCurrentValue(val) {
      if (!val.adminName) {
        this.formData.lastname = '';
        this.formData.name = '';
      } else {
        this.arrname = val.adminName.split('_');
        this.formData.lastname = this.arrname[0] || '';
        this.formData.name = this.arrname[1] || '';
      }

      if (!val.adminKanaName) {
        this.formData.lastname_kana = '';
        this.formData.name_kana = '';
      } else {
        this.arrnameKana = val.adminKanaName.split('_');
        this.formData.lastname_kana = this.arrnameKana[0] || '';
        this.formData.name_kana = this.arrnameKana[1] || '';
      }

      this.formData.email = val.adminEmail;
      this.formData.company_name = val.companyName;
      this.formData.phone_number = val.adminPhoneNumber;
    },
  },
};
</script>
